import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { TranslateService } from '@ngx-translate/core';
import { AppService } from '../../service/app/app.service';
import { toggleAnimation } from 'src/app/shared/animations';
import { AnalitycsService } from 'src/app/shared/service/analitycs.service';
// import moment from 'moment';

@Component({
  selector: 'app-languajes',
  templateUrl: './languajes.component.html',
  styleUrl: './languajes.component.css',
  animations: [toggleAnimation],
})
export class LanguajesComponent {
  store: any;
  currYear: number = new Date().getFullYear();
  constructor(
    public translate: TranslateService,
    public storeData: Store<any>,
    public router: Router,
    private appSetting: AppService,
    private analitycs: AnalitycsService,
  ) {
    this.initStore();
    //Reactive-Form
  }

  async initStore() {
    // this.analitycs.logEvent('init login', {
    //   view: 'login',
    //   action: 'click',
    //   at: moment().format('YYYY-MM-DD HH:mm:ss'),
    // });
    this.storeData
      .select((d) => d.index)
      .subscribe((d) => {
        this.store = d;
      });
  }

  changeLanguage(item: any) {
    // this.analitycs.logEvent('changeLanguage', {
    //   view: 'login',
    //   action: 'click',
    //   at: moment().format('YYYY-MM-DD HH:mm:ss'),
    // });
    this.translate.use(item.code);
    this.appSetting.toggleLanguage(item);
    if (this.store.locale?.toLowerCase() === 'ae') {
      this.storeData.dispatch({ type: 'toggleRTL', payload: 'rtl' });
    } else {
      this.storeData.dispatch({ type: 'toggleRTL', payload: 'ltr' });
    }
    // window.location.reload();
  }
}
